// removed by extract-text-webpack-plugin
module.exports = {"flexContent":"SaveSearch__flexContent__c58c6eca","contentWrapper":"SaveSearch__contentWrapper__c58c6eca","flexContentWrapper":"SaveSearch__flexContentWrapper__c58c6eca","button":"SaveSearch__button__c58c6eca","smallButton":"SaveSearch__smallButton__c58c6eca"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/SaveSearch/SaveSearch.scss
// module id = 3458
// module chunks = 4